import { Box } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components';
// import accountingIcon from '../common/images/Layer 2 (1).svg';
import peopleIcon from '../common/images/Layer 2 (2).svg';
import payrollIcon from '../common/images/Layer 2 (3).svg';
import performanceIcon from '../common/images/performance_icon.svg';
import timeIcon from '../common/images/Group 20.png';
import assetIcon from '../common/images/Layer 2 (4).svg';
// import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
// import TableCont from './Table';
import {
  CustomText
  //  FlexBox
} from '../common/Reusables';
import { Stack } from '@mui/material';
import Guide from './Guide';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const helpData = [
  // {
  //   icon: accountingIcon,
  //   title: 'Accounting Guide',
  //   subText: '10 available videos to learn more',
  //   vidoes: []
  // },

  {
    id: 1,
    icon: peopleIcon,
    title: 'People Management Guide',
    subText: '8 available videos to learn more',
    videos: [
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/How+to+View+Time+off+Balance+and+Manage+Leave+Requests.mp4',
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/How+to+Send+MyEdge+Invites+to+Employees.mp4',
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/How+to+Set+Up+Time+Off+Management+on+BizEdge.mp4',
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/How+to+Onboard+New+Employees+on+BizEdge.mp4',
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/How+to+Manage+Employee+Benefits+on+BizEdge.mp4',
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/How+to+Add+and+Edit+Employees+Information+on+Bizedge.mp4',
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/Setting+Up+MyTeam+App+for+Line+Managers+on+BizEdge.mp4',
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/How+to+Create+User+Access+Levels+on+BizEdge.mp4'
    ]
  },
  {
    id: 2,
    icon: payrollIcon,
    title: 'Payroll Guide',
    subText: '2 available videos to learn more',
    videos: [
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/How+to+run+payroll+on+BizEdge.mp4',
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/How+to+make+Deductions+and+add+Allowances+on+BizEdge+Payroll.mp4',
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/How+to+Set+Up+Payroll+Access+Levels+on+BizEdge.mp4'
    ]
  },
  {
    id: 3,
    icon: timeIcon,
    title: 'Time & Attendace Guide',
    subText: '1 available videos to learn more',
    videos: [
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/How+to+Set+Up+Time+and+Attendance+on+BizEdge.mp4'
    ]
  },
  {
    id: 4,
    icon: assetIcon,
    title: 'Asset/Vehicles Guide',
    subText: '1 available video to learn more',
    videos: [
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/How+to+Manage+Assets+on+Bizedge+Web.mp4'
    ]
  },
  {
    id: 5,
    icon: performanceIcon,
    title: 'Performance Guide',
    subText: '2 available videos to learn more',
    videos: [
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/How+to+Create+an+Appraisal+Cycle+on+the+BizEdge+App.mp4',
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/How+to+Set+up+Performance+Life+Cycle+from+Competency+to+Preference+on+the+BizEdge+App.mp4',
      'https://bizedge-prod.s3.us-west-2.amazonaws.com/How+to+Add+Goals+and+Review+Employee+Appraisal+as+a+Line+Manager+on+the+BizEdge+App.mp4'
    ]
  }
];

const Guides = ({ stage, setStage }) => {
  // const mouseEnter = () => {
  //   let vid = document.getElementById('video');
  //   vid.onmouseenter = function () {
  //     vid.setAttribute('controls', 'controls');
  //   };
  // };

  // const formatVideoTitle = (url) => {
  //   if (url) {
  //     let str = url.split('/')[4];
  //     let title = str.replaceAll('+', ' ');
  //     return title;
  //   }

  //   return '';
  // };
  // const extractVideoTitle = (url) => {
  //   const extractedTitle = url.substring(url.lastIndexOf('/') + 1);
  //   const result = extractedTitle.replace(/\+/g, ' ');
  //   return result;
  // };
  const [view, setSelectedView] = useState(() => 0);
  const [guide, setSelectedGuide] = useState(() => 0);

  return (
    <>
      {view === 0 && (
        <Box sx={{ pt: '30px' }}>
          {helpData?.map((data) => (
            <Box
              key={data?.id}
              sx={{
                bgcolor: '#fff',
                p: '16px',
                border: '0.855px solid #e1e1e1',
                boxShadow: '0px 5px 18px 0px rgba(40, 41, 61, 0.07)',
                borderRadius: '10px',
                mb: '16px',
                cursor: 'pointer'
              }}
              onClick={() => {
                setSelectedView(1);
                setSelectedGuide(data?.id);
              }}
            >
              <Stack
                direction={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
              >
                <Stack direction={'row'} alignItems={'center'} gap={'10px'}>
                  <img src={data?.icon} alt={data?.title} />

                  <Stack>
                    <CustomText
                      fontSize='16px'
                      fontWeight={600}
                      color='#545454'
                    >
                      {data?.title}
                    </CustomText>
                    <CustomText fontSize='12px' color='#545454'>
                      {data?.subText}
                    </CustomText>
                  </Stack>
                </Stack>
                {/* <ArrowRightIcon /> */}
                <ChevronRightIcon />
              </Stack>
            </Box>
          ))}
        </Box>
      )}
      {view === 1 && (
        <Guide setSelectedView={setSelectedView} data={helpData[guide - 1]} />
      )}
    </>
  );
  // return (
  //   <Guides.Wrapper>
  //     {stage === 0 && (
  //       <>
  //         {/* <TextField
  //           style={{
  //             width: '100%'
  //           }}
  //           placeholder='Search for guide'
  //           color='secondary'
  //           variant='outlined'
  //           size='small'
  //           InputProps={{
  //             startAdornment: (
  //               <InputAdornment>
  //                 <IconButton>
  //                   <SearchIcon fontSize='small' />
  //                 </IconButton>
  //               </InputAdornment>
  //             )
  //           }}
  //         /> */}

  //         {data.map((item) => (
  //           <>
  //             <TableCont
  //               key={item.name}
  //               name={item.title}
  //               subText={item.subText}
  //               handler={() => {
  //                 setStage(item);
  //               }}
  //               bgColor='white'
  //               icon={item.icon}
  //             />
  //           </>
  //         ))}
  //       </>
  //     )}

  //     {stage !== 0 && (
  //       <>
  //         <FlexBox className='single-app' onClick={() => setStage(0)}>
  //           <KeyboardBackspaceIcon />
  //           <div className='h1'>{stage?.title}</div>
  //         </FlexBox>

  //         <Box className='overall' mt='41px'>
  //           {stage?.videos ? (
  //             stage?.videos.map((item, i) => (
  //               <Box className='video' key={i}>
  //                 <video
  //                   onMouseEnter={mouseEnter}
  //                   id='video'
  //                   height='100%'
  //                   width='100%'
  //                   // className={style["column"]}
  //                   autoPlay={false}
  //                   muted={true}
  //                   controlsList='nodownload'
  //                 >
  //                   <source src={item} />
  //                 </video>

  //                 <div className='heading'>{extractVideoTitle(item)}</div>
  //               </Box>
  //             ))
  //           ) : (
  //             <div className='heading'>No Content Available</div>
  //           )}
  //         </Box>
  //       </>
  //     )}
  //   </Guides.Wrapper>
  // );
};

export default Guides;

Guides.Wrapper = styled(Box)`
  margin-top: 20px;
  .single-app {
    justify-content: normal;
    gap: 11px;
    .h1 {
      font-weight: 600;
      font-size: 20px;
      line-height: 22px;
      text-align: center;
      color: #545454;
    }
  }
  .heading {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;
    color: #545454;
  }
  .sub {
    font-weight: normal;
    font-size: 12.64px;
    line-height: 117.86%;
    color: #545454;
    margin: 10px 0;
  }
  .overall {
    .video {
      .heading {
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 18px;
        color: #171717;
      }
      margin-top: 30px;
    }
  }
`;
